import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { Observable } from "rxjs/Observable";
import { Transition } from "./transition.model";

export class TransitionApiFacade extends RestrictedAccountObjectApiFacade<Transition> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Transition> {
        return this.GET(`/accounts/${accountId}/transitions/${id}`, options)
            .map(object => new Transition(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Transition>> {
        return this.CGET(`/accounts/${accountId}/transitions`, options)
            .map(objects => objects.map(object => new Transition(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.api-facade.ts